module.exports = __webpack_public_path__ + "img/navigation-menu.4f9583cf.svg";